"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.browserLocalStorage = void 0;
var fallbackStorage = {};
exports.browserLocalStorage = {
    setItem: function (key, value) {
        value = String(value);
        try {
            global.localStorage.setItem(key, value);
        }
        catch (err) {
            fallbackStorage[key] = value;
        }
    },
    getItem: function (key) {
        try {
            return global.localStorage.getItem(key);
        }
        catch (err) {
            return fallbackStorage[key];
        }
    },
    removeItem: function (key) {
        try {
            return global.localStorage.removeItem(key);
        }
        catch (err) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete fallbackStorage[key];
        }
    },
};
//# sourceMappingURL=local-storage.js.map